import axios from 'axios'
import store from '../store'
import { Notification, MessageBox, Message, Loading } from 'element-ui'

// 创建一个axios实例
const service = axios.create({
    headers: {
        'content-type': 'application/json;charset=UTF-8'
    },
    baseURL: store.state.downloadUrl,
    withCredentials: true,
    timeout: 2000
})


// 添加请求拦截器
service.interceptors.request.use(config => {
    // 在发送请求之前做某事，比如说 设置token
    // config.headers['token'] = 'token';
    if(store.state.token){
        config.headers.common['Authorization'] = store.state.token
    }
    return config;
}, error => {
    // 请求错误时做些事
    return Promise.reject(error);
});

// 添加响应拦截器
// //http reponse拦截器
axios.interceptors.response.use(response =>{
    // 未设置状态码则默认成功状态
    const code = response.data.code || 200;
      if (code === 401) {
        localStorage.removeItem('token');
        router.replace({
            path: '/login',
            query: {redirect: router.currentRoute.fullPath}//登录成功后跳入浏览的当前页面
        })
        return Promise.reject('无效的会话，或者会话已过期，请重新登录。')
    }else if (code === 500) {
        Message({ message: msg, type: 'error' })
        return Promise.reject(new Error(msg))
    } else if (code === 601) {
        Message({ message: msg, type: 'warning' })
        return Promise.reject('error')
    } else if (code !== 200) {
        Notification.error({ title: msg })
        return Promise.reject('error')
    } else {
        return response.data
    }
    },
    error=>{
      if(error.response){
        switch(error.response.status){
          case 401:
            localStorage.removeItem('token');
            router.replace({
              path: '/login',
              query: {redirect: router.currentRoute.fullPath}//登录成功后跳入浏览的当前页面
            })


        }
      }
   
    }
  )

export default service